import { render, staticRenderFns } from "./IndexCandidate.vue?vue&type=template&id=dd270ee0"
import script from "./IndexCandidate.vue?vue&type=script&lang=js"
export * from "./IndexCandidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports